module.exports = __webpack_public_path__ + "static/media/TheVanishingDeep.12a36920.jpg";